module.exports = __webpack_public_path__ + "img/1518852400.7e8399dd.jpg";